module.exports = __webpack_public_path__ + "static/04-no_handv4-af648609d0ff0f6be5dd1f2edf036269.png";